import { OrderReturnRequest } from '../../types/order';

export const getCurrencyCode = (
  returnsRequest: OrderReturnRequest,
  merchantCurrency: string
): string =>
  returnsRequest.customer_return_charge_currency ||
  returnsRequest.currency_code ||
  merchantCurrency;

export const formatCurrency = (
  amount: number,
  currencyCode?: string,
  symbol: string = 'narrowSymbol'
) =>
  `${new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: currencyCode,
    currencyDisplay: symbol,
    currencySign: 'accounting',
  }).format(amount)} ${currencyCode}`;
